import { Link } from '@tanstack/react-router';
import { formatPublishedAt } from '../../../lib/format-date';
import type { ArticleCardData } from './ArticleCard';
import { SmartImage } from '../../../components/media/SmartImage';
import { CategoryLink } from '../../../components/CategoryLink';

export function VideoNewsSection({
  mainHot,
  hots,
}: {
  mainHot: ArticleCardData | null;
  hots: ArticleCardData[];
}) {
  if (!mainHot) return null;
  const limited = hots.slice(0, 4);

  return (
    <section className="video-news-area">
      <div className="container custom-container">
        <div className="video-news-box">
          <div className="row">
            <div className="col-lg-8">
              <div className="video-news-post">
                <div className="section-title section-title-2">
                  <h3 className="title">لا يفوتك</h3>
                </div>
                <div className="video-news-post-item">
                  <div className="video-news-post-thumb">
                    <SmartImage media={mainHot.coverMedia} alt={mainHot.title} />
                  </div>
                  <div className="video-news-post-content">
                    <div className="post-meta">
                      {mainHot.category && (
                        <div className="meta-categories">
                          <CategoryLink slug={mainHot.category.slug} name={mainHot.category.name} />
                        </div>
                      )}
                      <div className="meta-date">
                        <span>{formatPublishedAt(mainHot.publishedAt)}</span>
                      </div>
                    </div>
                    <h3 className="title">
                      <Link to="/articles/$slug" params={{ slug: mainHot.slug }}>
                        {mainHot.title}
                      </Link>
                    </h3>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="populer-post">
                <div className="section-title">
                  <h3 className="title">المزيد</h3>
                </div>
                <div className="trending-sidebar-slider">
                  <div className="populer-post-slider">
                    {limited.map((item, ai) => (
                      <div className="gallery_item populer_item-style" key={item.id}>
                        <div className="gallery_item_thumb">
                          <SmartImage media={item.coverMedia} alt={item.title} />
                          <span>{ai + 1}</span>
                        </div>
                        <div className="gallery_item_content">
                          <h4 className="title">
                            <Link to="/articles/$slug" params={{ slug: item.slug }}>
                              {item.title}
                            </Link>
                          </h4>
                          {item.category && <span>{item.category.name}</span>}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
